import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=303576c2&"
import script from "./BaseChart.vue?vue&type=script&lang=js&"
export * from "./BaseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports